module.exports = __webpack_public_path__ + "img/44f.a8d15af9.png";